// src/components/white-screen-tool/ResolutionSelector.tsx
import { useTranslations } from '@/hooks/useTranslations';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';

interface ResolutionSelectorProps {
  resolution: string;
  customWidth: string;
  customHeight: string;
  onResolutionChange: (value: string) => void;
  onCustomWidthChange: (value: string) => void;
  onCustomHeightChange: (value: string) => void;
  resolutions: Array<{ label: string; width: number; height: number }>;
}

const ResolutionSelector = ({
  resolution,
  customWidth,
  customHeight,
  onResolutionChange,
  onCustomWidthChange,
  onCustomHeightChange,
  resolutions,
}: ResolutionSelectorProps) => {
  const { content } = useTranslations();

  return (
    <div className="space-y-4">
      <Select value={resolution} onValueChange={onResolutionChange}>
        <SelectTrigger className="w-full rounded-xl border border-border/50">
          <SelectValue placeholder={content.resolution?.selectPlaceholder || "Select resolution"} />
        </SelectTrigger>
        <SelectContent className="rounded-xl">
          {resolutions.map((res) => (
            <SelectItem key={res.label} value={res.label}>
              {res.label} ({res.width}x{res.height})
            </SelectItem>
          ))}
          <SelectItem value="custom">{content.resolution?.custom || "Custom"}</SelectItem>
        </SelectContent>
      </Select>

      {resolution === 'custom' && (
        <div className="grid grid-cols-2 gap-2">
          <Input
            type="number"
            value={customWidth}
            onChange={(e) => onCustomWidthChange(e.target.value)}
            placeholder={content.resolution?.width || "Width"}
            className="rounded-xl border border-border/50"
            aria-label={content.resolution?.width || "Width"}
          />
          <Input
            type="number"
            value={customHeight}
            onChange={(e) => onCustomHeightChange(e.target.value)}
            placeholder={content.resolution?.height || "Height"}
            className="rounded-xl border border-border/50"
            aria-label={content.resolution?.height || "Height"}
          />
        </div>
      )}
    </div>
  );
};

export default ResolutionSelector;